/* eslint-disable react/no-unused-state */
import React from 'react';
import { trans } from '../../../../../localization/index';
import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../../components/Modal/Modal';
import NowCheckbox from '../../../../../components/Common/NowCheckbox';
import NowSelect from '../../../../../components/Common/NowSelect';
import InputWrapper from '../../../../../components/Common/InputWrapper';
import './style.scss';
import { getReactSelectValue } from '../../../../../utils/utils';

const NOT_ARRIVE_REASON_ID = 1;
const DIFFERENT_SHOW_UP_NUMBER_REASON_ID = 2;
const DEFAULT_ADULT = 2;
const DEFAULT_CHILDREN = 0;
const MAX_PEOPLE = 200;

class TableReportOrderModal extends React.Component {
  state = {
    selectedReasonId: NOT_ARRIVE_REASON_ID,
    realAdults: DEFAULT_ADULT,
    realChildren: DEFAULT_CHILDREN,
  };

  onChangeAdult = option => {
    this.setState({
      realAdults: option.value,
    });
  };

  onChangeChildren = option => {
    this.setState({
      realChildren: option.value,
    });
  };

  onSubmitClick = () => {
    const { selectedReasonId, realAdults, realChildren } = this.state;
    const requestData =
      selectedReasonId === NOT_ARRIVE_REASON_ID
        ? { real_adult_number: 0 }
        : { real_adult_number: realAdults, children_number: realChildren };
    this.props.submitReportReason(requestData);
  };

  numberOfChildrenOptions = [...new Array(MAX_PEOPLE + 1).keys()].map(
    number => ({
      label: `${number} ${trans('children')}`,
      value: number,
    }),
  );

  numberOfAdultOptions = [...new Array(MAX_PEOPLE).keys()].map(number => ({
    label: `${number + 1} ${trans('adult')}`,
    value: number + 1,
  }));

  render() {
    const { isOpenDialog, onClose } = this.props;
    const { selectedReasonId, realAdults, realChildren } = this.state;
    return (
      <Modal isOpen={isOpenDialog} width="400px" className="reject-order">
        <ModalHeader>{trans('configure_order_reason')}</ModalHeader>
        <ModalBody className="padding-0">
          <ul className="list-reject-reason">
            <li className="item row align-items-center">
              <NowCheckbox
                value={selectedReasonId === NOT_ARRIVE_REASON_ID}
                name={trans('customer_not_arrive')}
                onChange={() =>
                  this.setState({ selectedReasonId: NOT_ARRIVE_REASON_ID })
                }
              />
            </li>
            <li className="item row align-items-center">
              <NowCheckbox
                value={selectedReasonId === DIFFERENT_SHOW_UP_NUMBER_REASON_ID}
                name={trans('wrong_number_of_customer_arrived')}
                onChange={() =>
                  this.setState({
                    selectedReasonId: DIFFERENT_SHOW_UP_NUMBER_REASON_ID,
                  })
                }
              />
              {selectedReasonId === DIFFERENT_SHOW_UP_NUMBER_REASON_ID && (
                <div style={{ display: 'flex', paddingLeft: '10px' }}>
                  <InputWrapper width={150}>
                    <NowSelect
                      value={getReactSelectValue(
                        this.numberOfAdultOptions,
                        realAdults,
                      )}
                      options={this.numberOfAdultOptions}
                      isClearable={false}
                      onChange={this.onChangeAdult}
                    />
                  </InputWrapper>
                  <InputWrapper width={150}>
                    <NowSelect
                      value={getReactSelectValue(
                        this.numberOfChildrenOptions,
                        realChildren,
                      )}
                      options={this.numberOfChildrenOptions}
                      getOptionValue={option => option.value}
                      isClearable={false}
                      onChange={this.onChangeChildren}
                    />
                  </InputWrapper>
                </div>
              )}
            </li>
          </ul>
        </ModalBody>
        <ModalAction>
          <ModalButton type="cancel" onClick={onClose}>
            {trans('mod_go_back')}
          </ModalButton>
          <ModalButton onClick={this.onSubmitClick}>
            {trans('send')}
          </ModalButton>
        </ModalAction>
      </Modal>
    );
  }
}

export default TableReportOrderModal;



// WEBPACK FOOTER //
// ./foody/src/pages/Table/TableManagement/components/TableReportOrderModal/TableReportOrderModal.jsx